import React, { Component } from "react"
import { Card, CardBody, CardHeader, CardTitle, CardSubtitle } from "reactstrap"
import { SpinnerOverlay } from "@gman/gman-react-bootstrap"
import ClientInvoiceFormExtended from "components/clientInvoices/form/ClientInvoiceFormExtended"
import InvoiceStatusBadge from "components/common/InvoiceStatusBadge"
import FeedbackAlert from "components/common/FeedbackAlert"
import Icon from "components/common/Icon"

class ClientInvoiceCardExtended extends Component {

    componentDidMount() {
        if (this.props.clientInvoiceId) {
            this.props.recordStateEvents.onLoadSingle(this.props.clientInvoiceId)
            this.props.onLoadDependentData()
        }
    }

    componentWillUnmount = () => {
        this.props.feedbackEvents.onFlushFeedback()        
        this.props.redirectEvents.onClearRedirect()
    }

    render() {
        var sourceData = this.props.sourceData
        var lastInvoicePayments = this.props.lastInvoicePayments
        var modals = sourceData.modals;
        var confirmEvents = this.props.confirmEvents
        var feedbackEvents = this.props.feedbackEvents
        var modalEvents = this.props.modalEvents
        
        return (
            <Card>
                <CardHeader>
                    <CardTitle>
                        {
                            sourceData.recordToUpdate ?
                                sourceData.recordToUpdate.number :
                                "Loading..."
                        }
                    </CardTitle>
                    <hr />
                    <CardSubtitle>
                        <Icon invoice />
                        <small>
                            <i>Invoice</i>
                        </small>
                    </CardSubtitle>
                    <br />
                    <InvoiceStatusBadge value={sourceData.recordToUpdate.status} />
                </CardHeader>
                <CardBody>
                    <FeedbackAlert {...feedbackEvents} feedback={sourceData.feedback} />
                    <SpinnerOverlay isLoading={sourceData.inProgress}>
                        <div>
                            <ClientInvoiceFormExtended
                                modals={modals}
                                modalEvents={modalEvents}
                                {...confirmEvents}
                                {...sourceData.recordToUpdate}
                                {...lastInvoicePayments}
                            />
                        </div>
                    </SpinnerOverlay>
                </CardBody>
            </Card>
        )
    }
}

export default ClientInvoiceCardExtended